module.exports = __webpack_public_path__ + "img/educationalGroupMedia.35ac54a5.svg";